import React, { useEffect, useState } from 'react';
import Styles from "../../styles.module.scss";
import { Icon } from '@iconify/react';
import DeleteModal from '../../../../modals/deleteModal'
import { getDetails, submitDetails } from './services';
import NotificationAlert from "../../../../components/notification";
import mixpanelData from '../../../../utils/mixpanel';
import ExperienceForm from '../../../../dashboardFormComponents/workForm'
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import { convertMilliSecToDateNew } from '../../../../utils/EllowUtils';


interface Props {

  ExperienceHandler: (event: any) => void
  ProjectHandler: (event: any) => void
  getUserDetails: (event: any) => void


  // Back: (event: React.MouseEvent<HTMLButtonElement>) => void
  defaultValues: {
    workHistory: { designation: string, companyName: string, description: string, startDate:number, endDate:number, stillWorking:boolean}[],
    project : {name:string, companyName:string, doneFor:string, contribution:string, skills:{skillName:string, skillId:number}[], link:string}[]
  },
  loginId: string | null
  displayNotification: (event: string) => void

}

const Experience: React.FC<Props> = ({
  ExperienceHandler,
  ProjectHandler,
  displayNotification,
  getUserDetails,
  loginId,
  defaultValues
}) => {
 
  
  const { v4: uuidv4 } = require('uuid');
  // const candidateId: string = localStorage.getItem('candidateid') || ''
  const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
  const [initialWorkValues, setInitialWorkValues] = useState<any>()
  const [section, setSection] = useState<string>('')
  const [notification, setNotification] = useState<boolean>(false)
  // const [message, setMessage] = useState<string>('')
  const [newWork, setNewWork] = useState<boolean>(false)
  // const [editWork, setEditWork] = useState<boolean>(false)
  // const [textArea, setTextArea] = useState<any>()
  const [workHistoryIndex, setWorkHistoryIndex]  = useState <any> (-1)
  const [visibleDeleteModal, setVisibleDeleteModal] = React.useState(true);
  const [editorState] = useState<any>(EditorState.createEmpty())

 
  useEffect(() => {
    if(defaultValues) {
    setInitialWorkValues(defaultValues.workHistory)
    }
    
  }, [defaultValues])
  
  

  const addWorkHistory = (data:any) => {
    
    
    let value = {
      workHistory:
     {
       workHistoryId: data.workHistoryId ? data.workHistoryId :uuidv4(),
       designation: data.designation,
       companyName: data.companyName,
       stillWorking: data.stillWorking,
       startDate: data.startDate,
       endDate:  data.endDate ,
       description: data.description,
       status: true
     },
     section:'workHistory',
     loginId: loginId,
     action: data.action

   
   }
    
    submitDetails(value).then((response) => {
      
      if( response && response.status === 1) {
        
        mixpanelData( data.action === 'add' ? 'MWP-Work History submitted' : 'MWP-Work History Updated', {
          'PhoneNumber': response && response.data[0].profile_metadata.phoneNumber ,
          'Email':response.data[0].profile_metadata.email,
          'designation': data.designation,
          'companyName': data.companyName,
          'stillWorking': data.stillWorking,
          'startDate': convertMilliSecToDateNew(data.startDate),
          'endDate':  convertMilliSecToDateNew(data.endDate) ,
          'distinct_id': response.data[0].profile_metadata.email,
          'workHistoryId': data.workHistoryId ? data.workHistoryId :uuidv4(),

        })
        mixpanelData(data.action === 'add' ? 'New MWP - Work history submit' : 'New MWP - Work history updated', {
          'distinct_id': response.data[0].profile_metadata.email,
          'Candidate loginid':  loginId,
          'Candidate email':response.data[0].profile_metadata.email,
          'Work history id': data.workHistoryId ? data.workHistoryId :uuidv4(),
          'Designation': data.designation,
          'Company name': data.companyName,
          'Start date': convertMilliSecToDateNew(data.startDate),
          'End date':  convertMilliSecToDateNew(data.endDate) ,
        })
        getDetails(loginId).then((resp) => {                  
          setInitialWorkValues(resp.data[0].profile_metadata.workHistory)         
      })
      getUserDetails(loginId)
      displayNotification('Details saved successfully')
      }
    })  
    onClose();
  }


  const Delete = (section:string) => {
 
    let value = {
        "action": 'delete', 
        "section": 'workHistory',
        "loginId": loginId,
        "workHistory": {
            "workHistoryId":  initialWorkValues[workHistoryIndex].workHistoryId
      } 
    }
    let mixpanel = {
      'Candidate email':  profileMetadata.email,
      'Candidate loginid':  loginId,
      'Designation': initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].designation && initialWorkValues[workHistoryIndex].designation,
      'Company name': initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].companyName,
      'Still working': initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].stillWorking,
      'Start date': convertMilliSecToDateNew(initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].startDate),
      'End date':  convertMilliSecToDateNew(initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].endDate) ,
      'distinct_id':  profileMetadata.email,
      "Work history id":  initialWorkValues[workHistoryIndex].workHistoryId
    }
    submitDetails(value).then((response) => {     
      if(response && response.status === 1){
        mixpanelData('MWP-Work History Deleted', {
          'Email':response.data[0].profile_metadata.email,
          'designation': initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].designation && initialWorkValues[workHistoryIndex].designation,
          'companyName': initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].companyName,
          'stillWorking': initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].stillWorking,
          'startDate': convertMilliSecToDateNew(initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].startDate),
          'endDate':  convertMilliSecToDateNew(initialWorkValues[workHistoryIndex] && initialWorkValues[workHistoryIndex].endDate) ,
          'distinct_id': response.data[0].profile_metadata.email
        })  
        mixpanelData('New MWP - Work history deleted', mixpanel)
        deleteVisible()
        getDetails(loginId).then((resp) => {                  
          setInitialWorkValues(resp.data[0].profile_metadata.workHistory)
          displayNotification('Details deleted successfully')
        })
      }
    })  
    delete initialWorkValues[workHistoryIndex]
  }

  const workVisiblity = () => {
    setWorkHistoryIndex(-1)
    setNewWork(true)
  }


  const deleteVisible = () => {
    setVisibleDeleteModal(!visibleDeleteModal)
    setWorkHistoryIndex(-1)
  }

  const onClose = () => {
    setNotification(false)
    setWorkHistoryIndex(-1)
    setNewWork(false)
    // setEditWork(false)
  }

  const convert = (item:any) => {
    if (item) {
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== item) {
        try {
          // setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(item)))); 
           let abd = draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(item))).getCurrentContent()))
           let strippedHtml = abd.replace(/<[^>]+>/g, '');
           return strippedHtml
        }
        catch (e) {
          // setEditorState(EditorState.createWithContent(ContentState.createFromText(item)));
          return item
        }
      }
    }
   }

    return (
        <section>
        {notification && <NotificationAlert onClose={onClose } closable={true} >
           {/* {message} */}
        </NotificationAlert> }

       {/* {!eduvisible && ( <EducationModal ClickHandler={submitEducation} defaultValues={educationIndex !== -1 ? education[educationIndex] : ''} onClose={addEducationModal} /> )} */}
       {!visibleDeleteModal && ( <DeleteModal onClose={deleteVisible} onSubmit={Delete} section={section}/> )}
       
       {/* <Headline4>Academic Details</Headline4> */}
       { initialWorkValues && initialWorkValues.map((item:any, key:any) => {
           return(
               <div>
                   { key !== workHistoryIndex ? <div className={Styles.workExpWrapper} key={key}>
                   <div className={Styles.workExpCard}>
                     <div className={Styles.workExpHead}>
                      <div>
                        <h6>{item.designation} | {item.companyName}</h6>
                          <div className={Styles.expDate}>{ item.startDate && convertMilliSecToDateNew(item.startDate)}{(item.stillWorking || item.endDate !== null) && ' - ' }{ !item.stillWorking ? item.endDate !== null ? convertMilliSecToDateNew(item.endDate) : '' :'Present' }</div>
                            </div>                            
                               <div className={Styles.actions}>
                                   <Icon icon="lucide:edit-2" onClick={() => { setWorkHistoryIndex(key)}}/>
                                   <Icon icon="mdi:trash-can-outline" onClick={() => {deleteVisible(); setWorkHistoryIndex(key); setSection('workHistory')}} />
                               </div>
                           </div>
                          {item.description && <p>{convert(item.description).split('\n').map((item :any ,i : any) => <p key = {i}>{item}</p>)} </p> }
                       </div> 
                    </div> : <ExperienceForm ClickHandler={addWorkHistory} defaultValues={workHistoryIndex !== -1 ? initialWorkValues[workHistoryIndex] : ''} onClose={onClose} />}
               </div>
           )
       })}
       <div>
       { newWork ? <ExperienceForm ClickHandler={addWorkHistory} defaultValues={workHistoryIndex !== -1 ? initialWorkValues[workHistoryIndex] : ''} onClose={onClose} />
       : <button className={Styles.addWorkHistory}  onClick={workVisiblity}><Icon icon="fluent:add-circle-28-regular" />Work History</button> }
       </div>
   </section>
);
}
export default Experience

      